var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.408163,
    y: -0.408163,
    width: 79.1837,
    height: 79.1837,
    rx: 39.5918,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 79.1837 79.1837)",
    stroke: "#575757",
    strokeWidth: 0.816326
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4419_239183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3172 28.3096L29.8984 40.1953L41.3172 52.0811L41.8478 51.5717L31.2993 40.5986L50.5286 40.5986L50.5286 39.877L31.2356 39.877L41.8478 28.819L41.3172 28.3096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4419_239183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1551,
    height: 21.2245,
    fill: "white",
    transform: "translate(29.3906 52.0815) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessicon2);
export default __webpack_public_path__ + "static/media/processicon2.34523262ef87596ba87119994c6e2f06.svg";
export { ForwardRef as ReactComponent };